import { type ReactElement, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuthContext } from './AuthProvider';

export interface RequireAuthProps {
  children: ReactNode;
  redirectTo?: string;
  // Shown while Firebase restores the session. The host injects its own loading screen, since this
  // package does not depend on the UI façade.
  fallback?: ReactNode;
}

export function RequireAuth({
  children,
  redirectTo = '/login',
  fallback,
}: RequireAuthProps): ReactElement {
  const { firebaseUser, isLoading } = useAuthContext();
  const location = useLocation();

  if (isLoading) {
    // TODO: i18n
    return <>{fallback ?? <div role="status" aria-busy="true">Cargando…</div>}</>;
  }
  if (firebaseUser === null) {
    const from = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`${redirectTo}?from=${from}`} replace />;
  }
  return <>{children}</>;
}
